import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-handle-transaction-result-dialog',
  templateUrl: './handle-transaction-result-dialog.component.html',
  styleUrls: ['./handle-transaction-result-dialog.component.scss']
})
export class HandleTransactionResultDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<HandleTransactionResultDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
  }

  close(){
    this.dialogRef.close()
  }
}
